import { useForm } from "react-hook-form";
import DateInput from "../../../UI/PageInput/DateInput";
import PrimaryButton from "../../../UI/buttonUI/PrimaryButton";
import { History } from "lucide-react";
import { EXPENSE_HISTORY } from "../../../../api/allApi_List";
import { formatDateString } from "../../../../functions/dateTime/formatDateString";

const ExpenseHistorySelector = ({ historyLoaded, getHistory }) => {
  const {
    register,
    setValue,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      from: "",
      to: "",
    },
  });

  const { from, to } = watch();

  const onSubmit = () => {
    getHistory(
      `${EXPENSE_HISTORY}${formatDateString(from)}/${formatDateString(to)}`
    );
  };
  return (
    <div className="bg-white px-5 py-3 rounded-lg border-1 border-dBlue-100 max-lg:p-3">
      <p className="text-lg pb-2 font-figtreeMedium">Select Date Range</p>
      <form
        onSubmit={historyLoaded ? () => {} : (e) => handleSubmit(onSubmit)(e)}
        className="md:flex md:gap-2 items-center"
      >
        <div className="flex gap-2">
          <DateInput
            label="From *"
            name={"from"}
            value={from}
            setValue={setValue}
            register={{
              ...register("from", {
                required: "Please select start date",
              }),
            }}
            error={errors.from}
            disableFutureDays={true}
          />
          <DateInput
            label="To *"
            name={"to"}
            value={to}
            setValue={setValue}
            register={{
              ...register("to", {
                required: "Please select end date",
              }),
            }}
            error={errors.to}
            disableFutureDays={true}
          />
        </div>
        <PrimaryButton
          btnText={historyLoaded ? "Loading..." : "Get History"}
          loading={historyLoaded}
          Icon={History}
          size={18}
        />
      </form>
    </div>
  );
};

export default ExpenseHistorySelector;
